import { RouteComponentProps } from 'react-router-dom';
import { Plan } from './plan';

export function PlanMobileUnit(props: RouteComponentProps<{ id: string }>) {
  return Plan({ ...props, unitType: 'mobileUnit' });
}
export function PlanTechnician(props: RouteComponentProps<{ id: string }>) {
  return Plan({ ...props, unitType: 'user' });
}
